import React from 'react';

interface Props {
    size?: 'sm' | 'md';
}

const SIZE_MAP = {
    sm: 'w-4 h-4 border',
    md: 'w-6 h-6 border-2',
};

const InlineSpinner: React.FC<Props> = ({ size = 'md' }) => (
    <div className="flex justify-center py-12">
        <div
            className={`${SIZE_MAP[size]} border-semantic-border-brand border-t-transparent rounded-full animate-spin`}
        />
    </div>
);

export default InlineSpinner;
